import { useEffect, useState } from "react";
import { Clock, LogOut, RefreshCw, XCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { LangSwitch } from "@/components/LangSwitch";
import { Logo, Wordmark } from "@/components/Logo";
import { BigButton } from "@/components/ui-kit";

export function AccountGate({ children }) {
  const { user, logout, t } = useApp();
  const [st, setSt] = useState(null);
  const load = () => api.get("/account/status").then((r) => setSt(r.data)).catch(() => setSt((s) => s || { approval: "approved" }));
  useEffect(() => { if (!user?.shop_id) return undefined; load(); const id = setInterval(load, 15000); return () => clearInterval(id); }, [user?.shop_id]);
  if (!user?.shop_id || st?.approval === "approved") return children;
  if (!st) return <div className="min-h-screen grid place-items-center font-bold" data-testid="account-gate-loading">{t("loading")}</div>;
  const rejected = st.approval === "rejected";
  return (
    <div className="min-h-screen bg-[#0B2A5B] text-white flex flex-col" data-testid="account-pending-page">
      <header className="h-16 px-5 flex items-center gap-3 border-b border-white/10"><Logo className="w-9 h-9" /><Wordmark size="sm" /><span className="flex-1" /><LangSwitch compact /></header>
      <main className="flex-1 grid place-items-center p-6">
        <div className="max-w-md w-full rounded-2xl bg-white text-[#12384A] p-8 space-y-4 text-center">
          <div className={`mx-auto w-16 h-16 rounded-full grid place-items-center ${rejected ? "bg-[#FDF5F5] text-[#C7353B]" : "bg-[#FFF7E6] text-[#E67E22]"}`}>{rejected ? <XCircle className="w-8 h-8" /> : <Clock className="w-8 h-8" />}</div>
          <h1 className="font-heading text-2xl" data-testid="account-pending-title">{t(rejected ? "acct_rejected_title" : "acct_pending_title")}</h1>
          <p className="text-sm text-muted-foreground">{t(rejected ? "acct_rejected_desc" : "acct_pending_desc", { shop: st.shop_name })}</p>
          {rejected && st.reason && <p className="text-sm font-semibold text-[#C7353B]" data-testid="account-reject-reason">{st.reason}</p>}
          <div className="flex gap-2 justify-center">
            <BigButton variant="soft" onClick={load} className="!h-11 text-sm" data-testid="account-refresh-btn"><RefreshCw className="w-4 h-4" />{t("acct_check_again")}</BigButton>
            <BigButton variant="soft" onClick={logout} className="!h-11 text-sm" data-testid="account-logout-btn"><LogOut className="w-4 h-4" />{t("sign_out_shop")}</BigButton>
          </div>
        </div>
      </main>
    </div>
  );
}
